var prisma = prisma || {};
(function () {

    if (!$.fn.waitMe) {
        return;
    }

    prisma.libs = prisma.libs || {};

    prisma.libs.waitMejs = {

        waitMe_config: {
            effect: 'rotation',
            text: 'Aguarde...',
            bg: 'rgba(255,255,255,0.7)',
            color: '#000',
            loaderStyle: {
                size: 'pl-size-xl',
                color: 'pl-green'
            },
            maxSize: '',
            textPos: 'vertical',
            fontSize: '',
            source: ''
        },

        //Configuração para indicador de ocupado no elemento interno do elemeno que tem a classe '.prisma-busy-indicator'.
        waitMe_config_inner_busy_indicator: {
            effect: 'rotation',
            text: 'Aguarde...',
            bg: 'rgba(255, 255, 255, 0.7)',
            color: '#000',
            loaderStyle: {
                size: 'pl-size-xl',
                color: 'pl-green'
            },
            maxSize: '',
            textPos: 'vertical',
            fontSize: '',
            source: ''
        }

    };

    prisma.ui.setBusy = function (elm, optionsOrPromise) {
        optionsOrPromise = optionsOrPromise || {};
        if (optionsOrPromise.always || optionsOrPromise['finally']) { //Verifica se é promise
            optionsOrPromise = {
                promise: optionsOrPromise
            };
        }

        var options = $.extend({}, optionsOrPromise);

        if (!elm) {
            if (options.blockUI != false) {
                prisma.ui.block();
            }

            $('body').waitMe(prisma.libs.waitMejs.waitMe_config);
        } else {
            var $elm = $(elm);
            var $busyIndicator = $elm.find('.prisma-busy-indicator'); //TODO: E se for mais de um elemento. Se houver elementos aninhados?
            if ($busyIndicator.length) {
                $busyIndicator.waitMe(prisma.libs.waitMejs.waitMe_config_inner_busy_indicator);
            } else {
                if (options.blockUI != false) {
                    prisma.ui.block(elm);
                }

                $elm.waitMe(prisma.libs.waitMejs.waitMe_config);
            }
        }

        if (options.promise) { //Suporta Q e jQuery.Deferred
            if (options.promise.always) {
                options.promise.always(function () {
                    prisma.ui.clearBusy(elm);
                });
            } else if (options.promise['finally']) {
                options.promise['finally'](function () {
                    prisma.ui.clearBusy(elm);
                });
            }
        }
    };

    prisma.ui.clearBusy = function (elm) {
        //TODO: Talvez melhor não chamar destravar se não for bloqueado por setBusy
        if (!elm) {
            prisma.ui.unblock();
            $('body').waitMe("hide");
        } else {
            var $elm = $(elm);
            var $busyIndicator = $elm.find('.prisma-busy-indicator');
            if ($busyIndicator.length) {
                $busyIndicator.waitMe("hide");
            } else {
                prisma.ui.unblock(elm);
                $elm.waitMe("hide");
            }
        }
    };

})();